var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_11612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91683 1.39167C3.70618 0.935969 4.62318 0.751661 5.5273 0.866994C6.43143 0.982327 7.27279 1.39094 7.92247 2.03021C8.57214 2.66948 8.99428 3.50414 9.12419 4.40628C9.2541 5.30842 9.08462 6.22828 8.64172 7.02489C8.19881 7.82149 7.50693 8.45089 6.67208 8.81664C5.83723 9.18239 4.90549 9.26431 4.01963 9.04984C3.13377 8.83538 2.34267 8.33635 1.76757 7.62925C1.19246 6.92215 0.865075 6.04598 0.835579 5.13501L0.833496 5.00001L0.835579 4.86501C0.858564 4.15686 1.06174 3.46628 1.42592 2.85852C1.79009 2.25077 2.30323 1.74591 2.91683 1.39167Z",
    fill: "#2F2B3D",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_11612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullets);
export default __webpack_public_path__ + "static/media/bullets.c235a40654eb0aceca605f109e096c7c.svg";
export { ForwardRef as ReactComponent };